// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__BwK9k","logo":"Header_logo__128GW","menu":"Header_menu__2QKkc","logout":"Header_logout__vY76z"};